import React from 'react'
import ZoneManagerCoordinatorList from '../../features/zoneManager/ZoneManagerCoordinatorList'

const ZoneManagerCoordinatorListPage = () => {
    return (
        <ZoneManagerCoordinatorList />
    )
}

export default ZoneManagerCoordinatorListPage